import type { PropType } from 'virtual-vue';
import type { NavBarBackground } from './nav-bar';

export const DEFAULT_NAV_BAR_TITLE = '';

export const DEFAULT_NAV_BAR_SHOW_LEFT = true;

export const DEFAULT_NAV_BAR_SHOW_RIGHT = false;

export const DEFAULT_NAV_BAR_BACKGROUND: NavBarBackground = 'default';

/**
 * 组件的props
 */
export const props = {
  /**
   * 标题文字
   * @default ''
   */
  title: {
    type: String,
    default: DEFAULT_NAV_BAR_TITLE,
  },
  /**
   * 背景类型：default 灰色 / white 白色 / transparent 透明
   * @default 'default'
   */
  background: {
    type: String as PropType<NavBarBackground>,
    default: DEFAULT_NAV_BAR_BACKGROUND,
  },
  /**
   * 是否显示左侧区域
   * @default true
   */
  showLeft: {
    type: Boolean,
    default: DEFAULT_NAV_BAR_SHOW_LEFT,
  },
  /**
   * 是否显示右侧区域
   * @default false
   */
  showRight: {
    type: Boolean,
    default: DEFAULT_NAV_BAR_SHOW_RIGHT,
  },
};
